const HIDDEN_KEY = 'bolita.aiFab.hidden';

/** Delay before showing the AI assistant bubble (ms). */
export const AI_FAB_DELAY_MS = 3 * 60 * 1000;

export function readAiFabHidden(): boolean {
  try {
    return localStorage.getItem(HIDDEN_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeAiFabHidden(hidden: boolean): void {
  try {
    if (hidden) localStorage.setItem(HIDDEN_KEY, '1');
    else localStorage.removeItem(HIDDEN_KEY);
  } catch {
    /* ignore quota / private mode */
  }
}
